export { deepEqual } from 'jamespot-user-api';

export function objectRemoveProperty(obj: Record<string, unknown>, prop: string) {
    return Object.keys(obj).reduce((object: Record<string, unknown>, key) => {
        if (key !== prop) {
            object[key] = obj[key];
        }
        return object;
    }, {});
}

/**
 * parse and catch the JSON.parse
 * @param str value to parse
 * @param defaultValue default value in case of the JSON.parse fails
 * @returns
 */
export function parse<T>(str: string, defaultValue: T): T {
    try {
        return JSON.parse(str);
    } catch (e) {
        return defaultValue;
    }
}
